import { Style } from 'inlines'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from './Card'

export interface TeamMember {
  image: string
  role: string
  name: string
  linkedIn?: string
}

export interface TeamCardProps extends TeamMember {
  style?: Style
}

export const TeamCard = ({
  image,
  role,
  name,
  linkedIn,
  style,
}: TeamCardProps) => {
  return (
    <Card
      title={name}
      subtitle={role}
      padded
      image={image}
      imageStyle={{
        width: '100%',
        height: 'auto',
        aspectRatio: '1 / 1',
        borderRadius: '1.25rem',
      }}
      style={style}
    >
      {linkedIn && (
        <Card.Actions>
          <a href={linkedIn} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon
              style={{
                color: 'var(--primary-blue)',
                width: '1.5rem',
              }}
              icon={faLinkedin}
              fontSize="1.5rem"
            />
          </a>
        </Card.Actions>
      )}
    </Card>
  )
}
